<template>
  <el-select class="input200" v-model="center.id" placeholder="请选择处理中心" @change="centerSelected" @focus="initCenters" :disabled="disabled" :clearable="clearable">
    <el-option
      v-for="item in centers"
      :key="item.id"
      :label="item.name"
      :value="item.id">
    </el-option>
  </el-select>
</template>

<script>
import { getCenter } from '@/api.js';

export default {
  name: 'CenterSelect',
  props: {
    center: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'center',
    event: 'change'
  },
  created() {
    this.getCenters()
  },
  data() {
    return {
      centers: []
    }
  },
  methods: {
    initCenters() {
      // 初始化处理中心选项
      if (!this.centers || !this.centers.length) {
        this.getCenters()
      }
    },
    getCenters() {
      // 获取处理中心列表
      return this.$request('get', getCenter)
      .then(res => {
        if (res) {
          this.centers = res
        }
      })
    },
    centerSelected() {
      // 选中处理中心
      const selected = this.centers.filter(i => i.id === this.center.id)[0]
      if (selected) {
        this.$set(this.center, 'name', selected.name)
      }

      this.$emit('change', Object.assign({}, this.center))
    },
    setCenter(data = {}) {
      // 从外部设置处理中心（可在外部只有id或name时调用，外部如果有完整的id和name，则直接给center对象赋值即可）
      const { id, name } = data
      if (!this.centers || !this.centers.length) {
        setTimeout(() => {
          this.setCenter(data)
        }, 200)
        return
      }

      if (id) {
        const item = this.centers.filter(i => i.id === id)[0]
        if (item) {
          const { id, name } = item
          this.$set(this.center, 'id', id)
          this.$set(this.center, 'name', name)
        }
      } else if (name) {
        const item = this.centers.filter(i => i.name === name)[0]
        if (item) {
          const { id, name } = item
          this.$set(this.center, 'id', id)
          this.$set(this.center, 'name', name)
        }
      }
    }
  }
}
</script>

<style>

</style>